import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class ModalsService {
    revertDisabled: boolean = true;
    rerunDisabled: boolean = true;
    exportDisabled: boolean = true;

    campaigns: any[];
    campaignSelectionExecutionId: any[] = [];
    restore: (name: string) => void;
    rerun: (name: string) => void;
    exportCampaigns: () => void;
    campaignsRestore: (ts) => void;
    campaignsRerun: (ts) => void;
}
